/* Vue setup */
import Vue from 'vue';

/* Require custom components (takes files like MyComponent and creates component aliases of my-component) */
const components = require.context('./components', true, /\.vue$/i);
components.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], components(key).default));

import outsideClick from './directives/click-outside';
Vue.directive('outside-click', outsideClick);

/* Setup store */
import createStore from './store';
const store = createStore();

/* Setup Router */
import router from './router';

/* Require helpers, alias methods onto vue prototype */
const helpers = require.context('./helpers', true, /\.js$/i);
helpers.keys().forEach((key) => {
    const helper = helpers(key).default;
    Object.keys(helper).forEach((method) => {
        if(method[0] === '_') {
            Vue.prototype[method] = helper[method];
        } else {
            Vue.prototype['$' + method] = helper[method];
        }
    }); 
});

import App from './components/App';

/* Vue instance */
export default new Vue({
    store: store,
    router: router,
    render: h => h(App)
});